// +----------------------------------------------------------------------
// | useAuth：登录态的薄封装，页面里只关心 login/logout/isLoggedIn/stats
// +----------------------------------------------------------------------
import { useUser } from '../lib/userStore';
import { getAuth } from '../lib/storage';

export default function useAuth() {
  const {
    user,
    stats,
    ready,
    isLoggedIn,
    doLogin,
    doRegister,
    doLogout,
    refreshUser,
    refreshStats,
    patchUser,
  } = useUser();

  return {
    user,
    stats,
    ready,
    isLoggedIn: isLoggedIn && !!user,
    login: doLogin,
    register: doRegister,
    logout: doLogout,
    refreshUser,
    refreshStats,
    patchUser,
    getAuth,
  };
}
